import type { CountListDetectedTypeKind } from "../../ExportExcelButtonV3/buildCountListRows";
import type { ItemTypeUnit } from "../useItemTypeSettings";
import type { BuildItemTypeSettingsByKey, ResolveItemTypeUnit } from "./types";

// Nothing stores a default: elements are counted, routes are measured
export const DEFAULT_ITEM_TYPE_UNIT_BY_KIND: Record<
  CountListDetectedTypeKind,
  ItemTypeUnit
> = {
  element: "piece",
  route: "m",
};

export const itemTypeSettingKey = (
  kind: CountListDetectedTypeKind,
  name: string,
): string => `${kind}:${name}`;

export const buildItemTypeSettingsByKey: BuildItemTypeSettingsByKey = ({
  settings,
}) =>
  new Map(
    settings.map((setting) => [
      itemTypeSettingKey(setting.kind, setting.floorPlanItemTypeName),
      setting,
    ]),
  );

export const resolveItemTypeUnit: ResolveItemTypeUnit = ({ kind, setting }) =>
  setting?.unit ?? DEFAULT_ITEM_TYPE_UNIT_BY_KIND[kind];
